import React from 'react'
import SpinnerAnimation from '../../../components/Spinner'
import googleIcon from '../../../img/idp/google.svg'

const SignIn = ({
    username, onUsernameChange, onUsernameBlur,
    password, onPasswordChange, onResendVerification,
    enableSubmit, isRequestProcessing, isCheckingSession,
    ssoEnabled, ssoInProgress,
    onSignIn,
    onGoogleSignIn,
    onRegisterClick,
    onForgotPass
}) => {
  return (
    <div>
      <p>
        <input
          className    = "login-control-username"
          type         = "text"
          autoComplete = "username"
          placeholder  = "Username/Email"
          value        = { username }
          onChange     = { onUsernameChange }
          onBlur       = { onUsernameBlur }
          disabled     = { isRequestProcessing || isCheckingSession }
        />
      </p>
      <p>
        <input
          type         = "password"
          className    = "login-control-pass"
          autoComplete = "current-password"
          placeholder  = "Password"
          value        = { password }
          onChange     = { onPasswordChange }
          onKeyDown    = {e => {if (e.code === "Enter") { e.preventDefault(); onSignIn() }}}
          disabled     = { isRequestProcessing || isCheckingSession }
        />
      </p>
      <p>
        <button autoFocus
                type={"button"}
                className = "login-submit"
                onClick   = { onSignIn }
                disabled  = { !enableSubmit }
        >
          {isRequestProcessing ? 'Authorizing' : "Sign in" }
          <SpinnerAnimation style = {{float: "right", display: isRequestProcessing ? "" : "none"}}/>
        </button>
      </p>
      {ssoEnabled && <div className="sso-divider"><span>or</span></div>}
      {ssoEnabled && (
        <p className="sso-buttons">
          <button
            type="button"
            className="sso-btn"
            disabled={ssoInProgress}
            onClick={onGoogleSignIn}
          >
            <img src={googleIcon} alt="" className="sso-icon" />
            {ssoInProgress ? 'Signing in…' : 'Sign in with Google'}
          </button>
        </p>
      )}
      <p className="signup-block">
        <button
          type = "button"
          className = "signup-btn"
          onClick   = { onRegisterClick }
          title     = {"Click here to register"}
        >
          Not registered yet?
        </button>
        <button type="button"
                id={"forgotPass"}
                className="signup-btn"
                onClick={onForgotPass}
        >
          Reset Password
        </button>
        <button type="button"
                id={"haveCode"}
                className="signup-btn"
                onClick={onResendVerification}
                disabled={!username || !password}
        >
          Re-send confirmation
        </button>
        <button
          className="signup-btn link"
          title="Send a message to Plex Research"
        >
          <a href={"https://www.plexresearch.com/contact.html"} target={"_blank"}>
            {"Contact Plex"}
          </a>
        </button>
      <br/>
    </p>
</div>
  )
}

export default SignIn;
